import React, { memo } from "react";

const AzureIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_8981_47448)">
        <g clipPath="url(#clip1_8981_47448)">
          <path
            d="M5.33759 0.995517H10.0665L5.15739 15.5493C5.13229 15.6237 5.09576 15.6936 5.04911 15.7567C5.00256 15.8198 4.94642 15.8752 4.8827 15.9209C4.81897 15.9667 4.74864 16.0022 4.67393 16.0262C4.59921 16.0502 4.5213 16.0626 4.44298 16.0626H0.762674C0.643207 16.0626 0.525338 16.0342 0.419056 15.9795C0.312661 15.9249 0.22082 15.8457 0.151154 15.7485C0.0814425 15.6513 0.0358377 15.539 0.0181016 15.4207C0.000321383 15.3024 0.0111094 15.1815 0.049267 15.0683L4.62298 1.50835C4.64796 1.43403 4.68452 1.36411 4.73126 1.30098C4.77781 1.23785 4.83415 1.18251 4.89768 1.13676C4.96141 1.09101 5.03173 1.05545 5.10645 1.03148C5.18116 1.0075 5.25908 0.995117 5.33739 0.995117V0.995317L5.33759 0.995517Z"
            fill="url(#paint0_linear_8981_47448)"
          />
          <path
            d="M14.0547 16.0629H9.80845C9.7611 16.0629 9.71375 16.0585 9.667 16.0495C9.62046 16.0407 9.57471 16.0276 9.53056 16.0102C9.4864 15.9928 9.44405 15.9712 9.4039 15.946C9.36379 15.9207 9.32614 15.8917 9.29142 15.8593L4.47278 11.3591C4.42181 11.3116 4.38632 11.2497 4.37089 11.1817C4.35548 11.1137 4.3609 11.0427 4.38645 10.9778C4.412 10.9129 4.45649 10.8572 4.51413 10.8179C4.57187 10.7788 4.63999 10.7578 4.70971 10.7578H12.2086L14.0543 16.0631L14.0547 16.0629Z"
            fill="#0078D4"
          />
          <path
            d="M10.0832 0.996103L6.77283 10.7591L12.1816 10.7579L14.037 16.0632H9.80666C9.76291 16.0628 9.71916 16.0588 9.67601 16.051C9.63286 16.0432 9.5905 16.0318 9.54935 16.0166C9.46682 15.9865 9.39007 15.9425 9.3224 15.8866L6.06961 12.8507L5.15903 15.5361C5.13545 15.6033 5.10309 15.667 5.06273 15.7255C4.98185 15.8433 4.87122 15.9375 4.74209 15.9986C4.6778 16.029 4.60974 16.0507 4.53972 16.0632H0.764511C0.643845 16.0636 0.524777 16.0348 0.417497 15.9792C0.3102 15.9238 0.21784 15.8433 0.148224 15.7445C0.0786091 15.6458 0.033785 15.5318 0.0175412 15.4121C0.00135613 15.2923 0.0141683 15.1704 0.0548997 15.0567L4.62122 1.51912C4.645 1.44341 4.68076 1.37209 4.72711 1.30776C4.77326 1.24343 4.82959 1.18669 4.89352 1.13994C4.95745 1.0932 5.02857 1.05684 5.10389 1.03246C5.1792 1.00809 5.25812 0.995704 5.33743 0.996103H10.0834H10.0832Z"
            fill="url(#paint1_linear_8981_47448)"
          />
          <path
            d="M15.9506 15.0689C15.9888 15.1822 15.9995 15.303 15.982 15.4213C15.9642 15.5395 15.9187 15.6519 15.8491 15.7491C15.7794 15.8462 15.6876 15.9254 15.5813 15.98C15.475 16.0346 15.3572 16.0631 15.2376 16.0631H9.96707C10.0865 16.0631 10.2044 16.0346 10.3109 15.98C10.4172 15.9255 10.5091 15.8462 10.5788 15.7491C10.6485 15.652 10.6941 15.5395 10.7118 15.4213C10.7296 15.303 10.7188 15.1821 10.6807 15.0689L6.10676 1.50852C6.05641 1.35915 5.96048 1.22932 5.83247 1.13734C5.76894 1.09159 5.69862 1.05623 5.6241 1.03225C5.54958 1.00828 5.47167 0.996094 5.39355 0.996094H10.6639C10.7422 0.996094 10.8199 1.00828 10.8946 1.03225C10.9692 1.05623 11.0395 1.09179 11.1032 1.13734C11.1667 1.18309 11.2229 1.23842 11.2694 1.30135C11.316 1.36428 11.3523 1.43421 11.3775 1.50852L15.9514 15.0689H15.9506Z"
            fill="url(#paint2_linear_8981_47448)"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8981_47448"
          x1="7.06347"
          y1="2.11228"
          x2="2.14894"
          y2="16.6301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#114A8B" />
          <stop offset="1" stopColor="#0669BC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8981_47448"
          x1="8.59541"
          y1="8.87734"
          x2="7.45867"
          y2="9.26291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.3" />
          <stop offset="0.1" stopOpacity="0.2" />
          <stop offset="0.3" stopOpacity="0.1" />
          <stop offset="0.6" stopOpacity="0.1" />
          <stop offset="1" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8981_47448"
          x1="7.96769"
          y1="1.68932"
          x2="13.3617"
          y2="16.0594"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3CCBF4" />
          <stop offset="1" stopColor="#2892DF" />
        </linearGradient>
        <clipPath id="clip0_8981_47448">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_8981_47448">
          <rect
            width="16"
            height="15.0976"
            fill="white"
            transform="translate(0 0.980469)"
          />
        </clipPath>
      </defs>
    </svg>
  );
});

export { AzureIcon };
